var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { Button } from '@ui/atoms/Button/Button';
import { translate } from '@utils/i18n';
import InspectionsReviewService from '@features/AiToReviewInspectionsIndex/services/InspectionsReviewService';
const namespace = 'features.ai_to_review_inspections.index';
/**
 * IP-14971: lets the back office reopen a review that was auto-stamped iim_completed
 * (e.g. when only office-only issues remained, or the tech silently skipped everything),
 * which otherwise permanently hides "Send For Correction". Only renders on a completed
 * review; on success it reloads so the server re-renders the editable review actions.
 */
function ReopenReviewButton({ inspectionId, buttonText, iimReviewStatus, isVisible }) {
    const [buttonVisible, setButtonVisible] = useState(isVisible);
    const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(() => {
        const handleTabVisibilityChange = (event) => {
            var _a, _b;
            setButtonVisible((_b = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.isVisible) !== null && _b !== void 0 ? _b : true);
        };
        document.addEventListener('tabVisibilityChange', handleTabVisibilityChange);
        // Check active tab state on mount in case the jQuery event fired before React mounted
        const activeTab = document.querySelector('.workspace__tabs .active a');
        if (activeTab) {
            setButtonVisible(activeTab.getAttribute('href') === '#iim-issues');
        }
        return () => {
            document.removeEventListener('tabVisibilityChange', handleTabVisibilityChange);
        };
    }, []);
    if (!buttonVisible || iimReviewStatus !== 'iim_completed') {
        return null;
    }
    const handleClick = () => __awaiter(this, void 0, void 0, function* () {
        if (isSubmitting) {
            return;
        }
        setIsSubmitting(true);
        try {
            yield InspectionsReviewService.reopenReview({ inspectionId: String(inspectionId) });
            // Reload so the server re-renders Send For Correction / Complete Review and the
            // IIM review panel leaves read-only mode (all derived from iim_review_status).
            window.location.reload();
        }
        catch (error) {
            console.error('Error reopening review:', error);
            toast.error(translate('error_reopening_review', { namespace }));
            setIsSubmitting(false);
        }
    });
    return (React.createElement(Button, { variant: "secondary", onClick: () => {
            void handleClick();
        }, disabled: isSubmitting }, buttonText));
}
export default ReopenReviewButton;
